import { ENV } from '@/config/env'

const comefromConfig = {
  dev: {
    // 3.0健康平台
    health: {
      name: 'health', // 第三方唯一标识符
      usercenter: '//dev.daishu-component.com/health/#/mine', // 个人中心
      home: '//dev.daishu-component.com/health/#/', // 首页,
      windowTitle: '健康管理平台',
    },
    // 口袋有福---微信小程序
    pocketInfirmarySystem: {
      type: "wx-miniapp",
      name: "pocketInfirmarySystem", //第三方唯一标识符
      usercenter: "/pages/mine/index", // 个人中心
      home: "/pages/home/index", // 首页,
      webHome:"https://life.daishujiankang.com/pocket",
      windowTitle: '口袋有福',
      prefix: ""
    },
    // 袋鼠体检---微信小程序
    kangarooPhysicalSystem: {
      type: "wx-miniapp",
      name: "kangarooPhysicalSystem", //第三方唯一标识符
      usercenter: "/pages/mine/index", // 个人中心
      home: "/pages/home/index", // 首页,
      webHome:"https://test.daishutijian.com/services_component3/health/#/home",
      windowTitle: '袋鼠体检预约',
      prefix: ""
    },
    // 团检入口
    tuanjian: {
      name: 'tuanjian', // 第三方唯一标识符
      usercenter: '//dev.daishu-component.com/health/#/mine', // 个人中心
      home: '//dev.tuanjian.com/common#/', // 首页
      windowTitle: '袋鼠健康'
    },
    // 合伙人 经纪人端
    partner: {
      name: 'partner',
      home: '//dev.daishutijian.com/apps/frontend/project-agent/partner/stage/#/home',
      usercenter: '//dev.daishutijian.com/apps/frontend/project-agent/partner/stage/#/user-center',
      apply: '//dev.daishutijian.com/apps/frontend/project-agent/partner/stage/#/apply',
      windowTitle: '健康管理平台'
    },
    // 合伙人 用户端端
    user: {
      name: 'user',
      home: '//dev.daishutijian.com/apps/frontend/project-agent/user/h5/index.php',
      usercenter: '//dev.daishu-component.com/health/#/mine',
      windowTitle: '健康管理平台'
    }
  },
  test: {
    // 3.0健康平台
    health: {
      name: 'health', // 第三方唯一标识符
      usercenter: '//test.daishutijian.com/services_component1/health/#/mine', // 个人中心
      home: '//test.daishutijian.com/services_component1/health/#/', // 首页
      windowTitle: '健康管理平台'
    },
    // 口袋有福---微信小程序
    pocketInfirmarySystem: {
      type: "wx-miniapp",
      name: "pocketInfirmarySystem", //第三方唯一标识符
      usercenter: "/pages/mine/index", // 个人中心
      home: "/pages/home/index", // 首页,
      webHome:"https://life.daishujiankang.com/pocket",
      windowTitle: '口袋有福',
      prefix: ""
    },
    // 袋鼠体检---微信小程序
    kangarooPhysicalSystem: {
      type: "wx-miniapp",
      name: "kangarooPhysicalSystem", //第三方唯一标识符
      usercenter: "/pages/mine/index", // 个人中心
      home: "/pages/home/index", // 首页,
      webHome:"https://test.daishutijian.com/services_component3/health/#/home",
      windowTitle: '袋鼠体检预约',
      prefix: ""
    },
    // 团检入口
    tuanjian: {
      name: 'tuanjian', // 第三方唯一标识符
      usercenter: '//test.daishutijian.com/services_component1/health/#/mine', // 个人中心
      home: '//test.daishutijian.com/tuanjian1/public/#/', // 首页
      windowTitle: '袋鼠健康'
    },
    // 合伙人 经纪人端
    partner: {
      name: 'partner',
      home: '//test.daishutijian.com/tijian3/apps/frontend/project-agent/partner/stage/#/home',
      usercenter: '//test.daishutijian.com/tijian3/apps/frontend/project-agent/partner/stage/#/user-center',
      apply: '//test.daishutijian.com/tijian3/apps/frontend/project-agent/partner/stage/#/apply',
      windowTitle: '健康管理平台'
    },
    // 合伙人 用户端端
    user: {
      name: 'user',
      home: '//test.daishutijian.com/tijian3/apps/frontend/project-agent/user/h5/index.php',
      usercenter: '//test.daishutijian.com/services_component1/health/#/mine',
      windowTitle: '健康管理平台'
    }
  },
  prod: {
    // 3.0健康平台
    health: {
      name: 'health', // 第三方唯一标识符
      usercenter: '//apps.daishutijian.com/daishu_component/public/health/#/mine', // 个人中心
      home: '//apps.daishutijian.com/daishu_component/public/health/#/', // 首页
      windowTitle: '健康管理平台'
    },
    // 口袋有福---微信小程序
    pocketInfirmarySystem: {
      type: "wx-miniapp",
      name: "pocketInfirmarySystem", //第三方唯一标识符
      usercenter: "/pages/mine/index", // 个人中心
      home: "/pages/home/index", // 首页,
      webHome:"https://www.fulizhushou.cn/pocket",
      windowTitle: '口袋有福',
      prefix: ""
    },
    // 袋鼠体检---微信小程序
    kangarooPhysicalSystem: {
      type: "wx-miniapp",
      name: "kangarooPhysicalSystem", //第三方唯一标识符
      usercenter: "/pages/mine/index", // 个人中心
      home: "/pages/home/index", // 首页,
      webHome:"https://apps.dsjkyy.com/daishu_component/public/health/#/home",
      windowTitle: '袋鼠体检预约',
      prefix: ""
    },
    // 团检入口
    tuanjian: {
      name: 'tuanjian', // 第三方唯一标识符
      usercenter: '//apps.daishutijian.com/daishu_component/public/health/#/mine', // 个人中心
      home: '//apps.daishutijian.com/company/public/common#/', // 首页
      windowTitle: '袋鼠健康'
    },
    // 合伙人 经纪人端
    partner: {
      name: 'partner',
      home: '//apps.daishutijian.com/frontend/project-agent/partner/stage/index.php/#/home',
      usercenter: '//apps.daishutijian.com/frontend/project-agent/partner/stage/index.php/#/user-center',
      apply: '//apps.daishutijian.com/frontend/project-agent/partner/stage/index.php/#/apply',
      windowTitle: '健康管理平台'
    },
    // 合伙人 用户端端
    user: {
      name: 'user',
      home: '//apps.daishutijian.com/frontend/project-agent/user/h5/index.php',
      usercenter: '//apps.daishutijian.com/daishu_component/public/health/#/mine',
      windowTitle: '健康管理平台'
    }
  }
}

export default comefromConfig[ENV]
